module.exports = __webpack_public_path__ + "static/media/santa-reliquia-virgen-coromoto-patrona-venezuela.a02790ff.jpg";